import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { useParams } from "react-router-dom";
import { getAreasDesarrolloPlantelThunk } from "../store/reducers/fortalezas/fortalezasPlantel.thunks";
import { resetFortalezasPlantel, clearAreasError, setAreasPage } from "../store/reducers/fortalezas/fortalezasPlantel.reducer";
import AreasHeaderPlantel from "./fortalezas/fortalezas-plantel/AreasHeaderPlantel";
import AreasTablePlantel from "./fortalezas/fortalezas-plantel/AreasTablePlantel";
import AreaViewModalPlantel from "./fortalezas/fortalezas-plantel/AreaViewModalPlantel";
import AreaFormModalPlantel from "./fortalezas/fortalezas-plantel/AreaFormModalPlantel";
import ConfirmToggleAreaModalPlantel from "./fortalezas/fortalezas-plantel/ConfirmToggleAreaModalPlantel";
import Loader from "./UI/Loader";
import Alert from "./UI/Alert";
import Pagination from "./UI/Pagination";
import EmptyState from "./UI/EmptyState";

const FortalezasAreasListLayerPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { areasList, areasLoading, areasError, areasPage, areasPageSize, areasSearch, areasCount } = useSelector((state) => state.fortalezasPlantel);

  useEffect(() => {
    dispatch(getAreasDesarrolloPlantelThunk({ plantelId, page: areasPage, search: areasSearch }));
  }, [dispatch, plantelId, areasPage, areasSearch]);

  useEffect(() => () => { dispatch(resetFortalezasPlantel()); }, [dispatch]);

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <AreasHeaderPlantel />
        {areasError && <Alert message={areasError} variant="error" onClose={() => dispatch(clearAreasError())} />}
        {areasLoading ? <Loader center text="Cargando áreas..." delay={200} /> : (
          <>
            {areasSearch && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">{areasCount > 0 ? <>Se {areasCount === 1 ? "encontró" : "encontraron"} <strong className="text-primary">{areasCount}</strong> {areasCount === 1 ? "resultado" : "resultados"} para "{areasSearch}"</> : <>No se encontraron resultados para "{areasSearch}"</>}</span>
              </div>
            )}
            {areasList.length === 0 ? <EmptyState icon={areasSearch ? "mdi:magnify-remove-outline" : "mdi:shape-outline"} title={areasSearch ? "No se encontraron áreas" : "No hay áreas registradas"} description={areasSearch ? "Intenta con otra búsqueda" : "Las áreas se gestionan desde el panel de administración"} /> : (
              <>
                <AreasTablePlantel areas={areasList} search={areasSearch} />
                <Pagination page={areasPage} count={areasCount} pageSize={areasPageSize} onPageChange={(p) => dispatch(setAreasPage(p))} />
              </>
            )}
          </>
        )}
      </div>
      <AreaViewModalPlantel />
      <AreaFormModalPlantel />
      <ConfirmToggleAreaModalPlantel />
    </div>
  );
};

export default FortalezasAreasListLayerPlantel;
